import ProductDescription from '../ProductDescription';
import LogoBlock from '../LogoBlock';
import { Link } from '@remix-run/react';

export function WhatsNewItem({ className }: { className: string }) {
    return (
        <a href={'/whats-new'} className={className}>
            <span className='relative pr-3'>
                What's New{' '}
                <span className='absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full animate-ping'></span>
                <span className='absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full'></span>
            </span>
        </a>
    );
}

const Footer = () => {
    return (
        <section className='py-10 bg-gray-50 sm:pt-16 lg:pt-24'>
            <div className='px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl'>
                <div className='grid grid-cols-1 lg:grid-cols-3 gap-y-16 gap-x-12'>
                    <div className='lg:col-span-3 lg:pr-8'>
                        <LogoBlock />

                        <p className='text-base max-w-xl leading-relaxed text-gray-600 mt-7'>
                            <ProductDescription />
                        </p>

                        <ul className='flex items-center space-x-3 mt-9'>
                            <li>
                                <a
                                    href='https://www.producthunt.com/posts/ai-perfect-assistant-gpt-for-office365'
                                    className='flex items-center justify-center text-white transition-all duration-200 bg-gray-800 rounded-full w-7 h-7 hover:bg-blue-600 focus:bg-blue-600'>
                                    <svg
                                        viewBox='0 0 56.7 56.7'
                                        fill='currentColor'
                                        version='1.1'
                                        xmlns='http://www.w3.org/2000/svg'
                                        className='w-4 h-4'>
                                        <g>
                                            <g>
                                                <path d='M28.35,3.5943c-13.6721,0-24.7556,11.0835-24.7556,24.7556c0,13.6722,11.0835,24.7557,24.7556,24.7557    c13.6722,0,24.7556-11.0835,24.7556-24.7557C53.1056,14.6778,42.0222,3.5943,28.35,3.5943z M31.6508,33.3011L31.6508,33.3011    l-7.0141,0.0001v7.4266h-4.9511V15.9721l11.9653,0.0001v-0.0001c4.7853,0,8.6644,3.8793,8.6644,8.6645    C40.3152,29.4219,36.4361,33.3011,31.6508,33.3011z' />
                                            </g>
                                            <g>
                                                <path d='M31.6508,20.9233L31.6508,20.9233l-7.0141,0.0001V28.35h7.0141v-0.0001c2.0508,0,3.7132-1.6625,3.7132-3.7133    C35.364,22.5858,33.7016,20.9233,31.6508,20.9233z' />
                                            </g>
                                        </g>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <p className='text-sm font-semibold tracking-widest text-gray-400 uppercase'>
                            Product
                        </p>

                        <ul className='mt-6 space-y-4'>
                            <li>
                                <a
                                    href='/'
                                    title='What is AI Perfect Assistant?'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    What is AI Perfect Assistant?{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/iframe/signin'
                                    title='Sign In'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    Sign In{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/referral-terms'
                                    title='Referral Program'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    Referral Program{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/pricing'
                                    title='Pricing'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Pricing{' '}
                                </a>
                            </li>

                            <li>
                                <a
                                    href='/integrations'
                                    title='Browse Integrations'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    Browse Integrations
                                </a>
                            </li>
                            <li>
                                <WhatsNewItem className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600' />
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className='text-sm font-semibold tracking-widest text-gray-400 uppercase'>
                            Help
                        </p>

                        <ul className='mt-6 space-y-4'>
                            <li>
                                <a
                                    href='https://help.perfectassistant.ai/'
                                    title='Help Center'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Help Center{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='mailto:hello@perfectassistant.ai'
                                    title='Contact Us'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Contact Us{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='https://help.perfectassistant.ai/feedback'
                                    title='Submit Feedback'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Submit Feedback{' '}
                                </a>
                            </li>

                            <li>
                                <a
                                    href='/terms'
                                    title='Terms & Conditions'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Terms & Conditions{' '}
                                </a>
                            </li>

                            <li>
                                <a
                                    href='/privacy'
                                    title='Privacy Policy'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Privacy Policy{' '}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className='min-w-64'>
                        <p className='text-sm font-semibold tracking-widest text-gray-400 uppercase'>
                            Apps &amp; Extensions
                        </p>

                        <ul className='mt-6 space-y-4'>
                            <li>
                                <a
                                    href='/chatgpt-for-microsoft-word'
                                    title='ChatGPT for Word'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    ChatGPT for Word{' '}
                                </a>
                            </li>

                            <li>
                                <a
                                    href='/chatgpt-for-microsoft-teams'
                                    title='ChatGPT for Teams'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    ChatGPT for Teams{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/chatgpt-for-microsoft-outlook'
                                    title='ChatGPT for Outlook'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    ChatGPT for Outlook{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/chatgpt-for-microsoft-excel'
                                    title='ChatGPT for Excel'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    ChatGPT for Excel{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/chatgpt-for-microsoft-powerpoint'
                                    title='ChatGPT for PowerPoint'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    ChatGPT for PowerPoint{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/chatgpt-for-telegram'
                                    title='ChatGPT for Telegram'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    ChatGPT for Telegram{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/chatgpt-for-chrome'
                                    title='ChatGPT for Chrome'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    ChatGPT for Chrome{' '}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className='text-sm font-semibold tracking-widest text-gray-400 uppercase'>
                            Alternative
                        </p>

                        <ul className='mt-6 space-y-4'>
                            <li>
                                <a
                                    href='/alternative/quillbot'
                                    title='QuillBot Alternative'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    QuillBot Alternative{' '}
                                </a>
                            </li>

                            <li>
                                <a
                                    href='/alternative/grammarly'
                                    title='Grammarly Alternative'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Grammarly Alternative{' '}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className='text-sm font-semibold tracking-widest text-gray-400 uppercase'>
                            Free AI Tools
                        </p>

                        <ul className='mt-6 space-y-4'>
                            <li>
                                <a
                                    href='/tools/content'
                                    title='Generate Content'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Generate Content{' '}
                                </a>
                            </li>

                            <li>
                                <a
                                    href='/tools/slides'
                                    title='Generate Presentations'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Generate Presentations{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/tools/mail'
                                    title='Generate Email Messages'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Generate Email Messages{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/tools/chat'
                                    title='Tools for Business'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Tools for Business{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/tools/social%20media'
                                    title='Tools for Social Media'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Tools for Social Media{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/tools/advertisement'
                                    title='Tools for Advertisement'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Tools for Advertisement{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/tools/video'
                                    title='Tools for Video'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Tools for Video{' '}
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/tools'
                                    title='Browse All Tools'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Browse All Tools{' '}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className='text-sm font-semibold tracking-widest text-gray-400 uppercase'>
                            Copilot Prompts
                        </p>

                        <ul className='mt-6 space-y-4'>
                            <li>
                                <a
                                    href='/copilot/best-copilot-prompts-for-powerpoint'
                                    title='Prompts for PowerPoint'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Prompts for PowerPoint
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/copilot/best-copilot-hr-prompts-for-word'
                                    title=' Prompts for Word'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Prompts for Word
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/copilot/top-copilot-prompts-for-outlook'
                                    title='Prompts for Outlook'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Prompts for Outlook
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/copilot/top-copilot-prompts-for-excel'
                                    title='Prompts for Excel'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Prompts for Excel
                                </a>
                            </li>
                            <li>
                                <a
                                    href='/copilot/most-efficient-copilot-prompts-for-one-note'
                                    title='Prompts for OneNote'
                                    className='flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600'>
                                    {' '}
                                    Prompts for OneNote
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <hr className='mt-16 mb-10 border-gray-200' />

                <p className='text-sm text-center text-gray-600'>
                    © Copyright 2023 &mdash; {new Date().getFullYear()} &bull;
                    All Rights Reserved by{' '}
                    <Link
                        className='underline decoration-dotted'
                        to='https://ipirozhenko.com?ref=assistant'>
                        IE Ilia Pirozhenko
                    </Link>
                </p>
            </div>
        </section>
    );
};

export default Footer;
